<template>
  <section :id="`${identifier}Question`" class="question-view">
    <div class="row align-center justify-center">
      <div class="column small-6 medium-12">
        <NumberBlock class="animate number-block" :number="questionIndex + 2" />
        <p class="animate share-note" v-html="data.shareNote"></p>
        <TextInput
          class="animate question-inputs"
          :action="nextQuestion"
          :data="data"
        />
        <div class="button-container">
          <ButtonElement
            :class="{'animate justify-self-center secondary': true, tertiary: lastQuestion}"
            type="button"
            :text="data.previousButtonText"
            :action="previousQuestion"
          ></ButtonElement>
          <ButtonElement
            :class="{'animate justify-self-center secondary': true, tertiary: lastQuestion, disabled: isDisabled}"
            type="button"
            :text="data.nextButtonText"
            :action="nextQuestion"
          ></ButtonElement>
        </div>
        <PageMarkers class="animate question-markers" />
      </div>
    </div>

    <!-- <div class="design-bg question-design-bg" :style="'background-image: url(' + require(`@/assets/images/question-${questionIndex + 2}.jpg`) + ');'"></div> -->

  </section>
</template>

<script>
import ButtonElement from './ButtonElement.vue'
import NumberBlock from './NumberBlock.vue'
import PageMarkers from './PageMarkers.vue'
import TextInput from './TextInput.vue'
import router from '@/router'
import advanceQuestion from '@/shared/advanceQuestion'
import subtractQuestion from '@/shared/subtractQuestion'

export default {
  name: "QuestionsVue",
  props: {
    questionIndex: Number
  },
  components: {
    ButtonElement,
    NumberBlock,
    PageMarkers,
    TextInput
  },
  computed: {
    numberOfPages() {
      return this.$store.state.numberOfPages
    },
    data() {
      return this.$store.state.questions[this.questionIndex]
    },
    identifier() {
      return this.data.identifier
    },
    isDisabled() {
      if(!this.value && this.value !== 0) {
        return true
      } else if(!!this.value || (this.value === 0 && this.data.allowZeroValue)) {
        return false
      }

      return true
    },
    value() {
      // gets the value from the store
      // associated with the questions identifier
      return this.$store.state.questionValues[this.identifier]
    },
    lastQuestion () {
      // + 2 to account for the intro and screener pages
      // - 1 to account for index starting at 0
      return this.questionIndex + 2 === this.numberOfPages - 1
    }
    
  },
  methods: {
    nextQuestion() {
      // the user hasn't entered a valid value yet
      if(!this.value && !this.data.allowZeroValue) return

      if(!this.lastQuestion) {
        // update store value to show next question in transition
        advanceQuestion(this.$store)
      } else {
        // this is the last question, redirect to results page
        router.push({name: 'results'})
      }
    },
    previousQuestion() {
      // update store value to show previous question in transition
      subtractQuestion(this.$store)
    }
  }
}
</script>

<style lang="scss">
// .question-design-bg {
//   background-size: 1440px 834px;
// }


  .question-view {
    padding: 60px 0;
    position: relative;
    width: 100%;

    .number-block {
      animation-delay: 1.5s;
      animation-name: fadeindown;
    }

    .share-note {
      animation-delay: 1.25s;
      animation-name: fadeindown;
      font-size: 20px;
      line-height: 1.05;
      margin-top: 30px;
      text-align: center;
    }

    .question-inputs {
      animation-delay: 1s;
      animation-name: fadein;

      label {
        animation-delay: 1s;
        animation-name: fadeindown;
      }
    }

    .button-container {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 auto 60px auto;
      max-width: 338px;
      width: 100%;
    }

    .secondary {
      animation-delay: 1.25s;
      animation-name: fadeinup;
    }

    .question-markers {
      animation-delay: 1.5s;
      animation-name: fadeinup;
    }
  }
</style>
